var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingHappinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000923_34542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.91553C2 3.82178 2.875 2.91553 4 2.91553H16C17.0938 2.91553 18 3.82178 18 4.91553V13.9155C18 15.0405 17.0938 15.9155 16 15.9155H11.6562L7.78125 18.8218C7.625 18.9468 7.4375 18.9468 7.25 18.8843C7.09375 18.7905 7 18.6343 7 18.4155V15.9155H4C2.875 15.9155 2 15.0405 2 13.9155V4.91553ZM6.5 8.35303C6.5 8.85303 6.6875 9.35303 7.03125 9.69678L9.625 12.2905C9.8125 12.478 10.1562 12.478 10.3438 12.2905L12.9062 9.69678C13.2812 9.35303 13.4688 8.85303 13.4688 8.35303C13.4688 7.29053 12.625 6.41553 11.5625 6.41553C11.0625 6.41553 10.5625 6.63428 10.2188 6.97803L9.96875 7.22803L9.75 6.97803C9.375 6.63428 8.90625 6.41553 8.40625 6.41553C7.34375 6.41553 6.46875 7.29053 6.46875 8.35303H6.5Z",
    fill: "url(#paint0_linear_40000923_34542)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40000923_34542",
    x1: 10,
    y1: 0.915527,
    x2: 10,
    y2: 20.9155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB9B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4545"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000923_34542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.915527)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingHappinessIcon);
export default __webpack_public_path__ + "static/media/saving-happiness-icon.8929eb58604b9a09c0a6d5d96c8d8e4a.svg";
export { ForwardRef as ReactComponent };